import { userApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useCoursesQuery = () =>
  useQuery({
    queryKey: ['courses'],
    queryFn: async () => {
      const { data } = await userApi.getCourses()
      return data.data
    }
  })
